export const toOptionalNumber = (value: unknown): number | undefined => {
  if (value == null) return undefined; // NOSONAR
  const n = typeof value === "string" ? Number(value.trim()) : Number(value);

  return Number.isFinite(n) ? n : undefined;
};

export const toOptionalString = (value: unknown): string | undefined => {
  if (value == null) return undefined; // NOSONAR

  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value) : undefined;
  }

  const str = typeof value === "string" ? value.trim() : "";
  return str || undefined;
};